module.exports = __webpack_public_path__ + "static/img/chat2.c2ce51e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/update/chat2.png
// module id = NhOW
// module chunks = 13 14